"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/react-wrapper.js":
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_2__);




// Improve the react-wrapper to handle initialization more robustly
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  var appContainer = document.querySelectorAll(container);
  // Default empty structure that matches your expected format
  var props = {
    data: {
      data: {
        options: {},
        selected: "",
        variants: [],
        subscription_plan: []
      }
    }
  };
  var parseJSONSafely = jsonString => {
    try {
      // First try standard JSON.parse
      return JSON.parse(jsonString);
    } catch (e1) {
      try {
        // Fallback to JSON6 if standard parsing fails
        return json_6__WEBPACK_IMPORTED_MODULE_2___default().parse(jsonString);
      } catch (e2) {
        console.error("Both JSON and JSON6 parsing failed:", e2);
        console.log("Problematic JSON content:", jsonString);
        return null;
      }
    }
  };
  return [...appContainer].map(appTarget => {
    // Check if the element is already initialized or is being initialized
    var initialized = appTarget.dataset.initialized === "true";
    if (appTarget && !initialized) {
      // Mark as being initialized to prevent double initialization
      appTarget.dataset.initializing = "true";
      if (propsEl) {
        var el = appTarget.querySelector(propsEl);
        if (el && el.innerHTML) {
          var parsed = parseJSONSafely(el.innerHTML);
          if (parsed) {
            props = {
              data: parsed
            };
            console.log("Parsed variant data successfully:", parsed);
          } else {
            console.error("Failed to parse variant data");
          }
        } else {
          console.warn("Props element not found or empty:", propsEl);
        }
      }

      // Mark as fully initialized
      appTarget.dataset.initialized = "true";
      appTarget.dataset.initializing = "false";
      try {
        var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_1__.createRoot)(appTarget);
        root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, {
          shopifyData: props
        }));

        // Reset global initialization flag
        if (window.videoCardsInitializing) {
          window.videoCardsInitializing = false;
        }
        return root;
      } catch (error) {
        console.error("Error rendering React component:", error);
        appTarget.dataset.initialized = "false";

        // Reset global initialization flag on error
        if (window.videoCardsInitializing) {
          window.videoCardsInitializing = false;
        }
        return null;
      }
    }
    return null;
  }).filter(Boolean);
});

/***/ }),

/***/ "./js/components/react/frequency-options.js":
/*!**************************************************!*\
  !*** ./js/components/react/frequency-options.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);


var FrequencyOptions = _ref => {
  var {
    sellingplan,
    selectedSellingPlan,
    onUpdate,
    subscriptionPlan
  } = _ref;
  var [showFrequencyOption, setShowFrequencyOption] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var extractFrequency = frequency => {
    if (frequency != selectedSellingPlan.frequency) {
      var [deliveryText] = frequency.split(',');
      if (!deliveryText) return;
      return deliveryText;
    }
  };
  document.addEventListener('click', ev => {
    var target = ev.target.closest('.dropdown_content');
    if (!target) {
      setShowFrequencyOption(false);
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency-container__freq-label variant-container__opt-label tw-m-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency-container__freq-options variant-container__var-options tw-font-normal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-py-2.5"
  }, " Deliver every "), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "dropdown_content !tw-font-normal tw-border tw-p-2.5",
    onClick: () => setShowFrequencyOption(!showFrequencyOption)
  }, selectedSellingPlan.frequency, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: showFrequencyOption ? 'dropdownOpen' : 'dropdownClose'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "7",
    viewBox: "0 0 10 7",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "0.707107",
    y1: "1.29289",
    x2: "5.70711",
    y2: "6.29289",
    stroke: "#000000",
    strokeWidth: "2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.29289",
    y1: "6.29289",
    x2: "9.29289",
    y2: "1.29289",
    stroke: "#000000",
    strokeWidth: "2"
  }))), showFrequencyOption && sellingplan && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency_options tw-bg-[#4c4c4c] tw-rounded-lg"
  }, sellingplan.map((sellplan, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    key: index,
    className: "frequency-container__freq-wrapper tw-pb-2 tw-px-1 ".concat(selectedSellingPlan.selling_plan_id === sellplan.selling_plan_id ? 'active' : ''),
    onClick: () => {
      onUpdate(sellplan);
      setShowFrequencyOption(false);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "frequency-container__freq-name variant-container__var-name tw-text-white tw-whitespace-nowrap"
  }, extractFrequency(sellplan.frequency)))))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FrequencyOptions);

/***/ }),

/***/ "./js/components/react/onetime-options.js":
/*!************************************************!*\
  !*** ./js/components/react/onetime-options.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var OnetimeOptions = _ref => {
  var {
    firstAvailableVariant,
    onUpdate,
    purchaseType
  } = _ref;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    // Listen for Alpine.js quantity changes
    var setupAlpineQuantityListener = () => {
      var quantityInput = document.getElementById("Quantity-selector-variant");
      if (quantityInput) {
        // Create a MutationObserver to watch for value changes
        var observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (mutation.type === "attributes" && mutation.attributeName === "value") {
              updateCartWithQuantity(quantityInput.value);
            }
          });
        });

        // Observe the input for value changes
        observer.observe(quantityInput, {
          attributes: true
        });

        // Also listen for direct input changes
        quantityInput.addEventListener("change", e => {
          updateCartWithQuantity(e.target.value);
        });

        // Listen for Alpine.js button clicks
        var minusButton = quantityInput.previousElementSibling;
        var plusButton = quantityInput.nextElementSibling;
        if (minusButton) {
          minusButton.addEventListener("click", () => {
            // Use setTimeout to allow Alpine.js to update the value first
            setTimeout(() => {
              updateCartWithQuantity(quantityInput.value);
            }, 10);
          });
        }
        if (plusButton) {
          plusButton.addEventListener("click", () => {
            // Use setTimeout to allow Alpine.js to update the value first
            setTimeout(() => {
              updateCartWithQuantity(quantityInput.value);
            }, 10);
          });
        }
      }
    };

    // Function to update cart with new quantity
    var updateCartWithQuantity = quantity => {
      if (purchaseType !== "onetime") return;

      // Update hidden quantity inputs in all forms
      document.querySelectorAll("[data-product-form]").forEach(form => {
        var hiddenQuantityInputs = form.querySelectorAll('[name="quantity"]');
        hiddenQuantityInputs.forEach(input => {
          if (input.id !== "Quantity-selector-variant") {
            input.value = quantity;
          }
        });
      });

      // Update cart line items if cart is open
      updateCartLineItems(quantity);
    };

    // Update cart line items if cart is open
    var updateCartLineItems = quantity => {
      var _document$querySelect;
      var cartItems = document.querySelectorAll("[data-cart-item]");
      if (cartItems.length === 0) return;

      // Find the current product in cart
      var productId = (_document$querySelect = document.querySelector("[data-product-id]")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
      if (!productId) return;
      cartItems.forEach(item => {
        var itemProductId = item.getAttribute("data-product-id");
        if (itemProductId === productId) {
          var quantityElement = item.querySelector("[data-item-quantity]");
          if (quantityElement) {
            quantityElement.textContent = quantity;
          }

          // Update price based on quantity
          var priceElement = item.querySelector("[data-item-price]");
          var unitPrice = Number.parseFloat(item.getAttribute("data-unit-price") || "0");
          if (priceElement && !isNaN(unitPrice)) {
            var totalPrice = (unitPrice * quantity).toFixed(2);
            priceElement.textContent = "".concat(totalPrice);
          }
        }
      });
    };

    // Setup the listener when component mounts
    setupAlpineQuantityListener();

    // Also setup after a short delay to ensure Alpine.js has initialized
    setTimeout(setupAlpineQuantityListener, 500);
    document.querySelectorAll("[data-product-form]").forEach(form => {
      form.addEventListener("submit", e => {
        var purchaseTypeRadios = form.querySelectorAll('[name="purchase_type"]');
        var oneTimeSelected = Array.from(purchaseTypeRadios).some(radio => radio.checked && radio.value === "onetime");
        if (oneTimeSelected) {
          var defaultVariantInput = form.querySelector("[data-default-variant]");
          if (defaultVariantInput) {
            var defaultVariantId = defaultVariantInput.getAttribute("data-default-variant");
            var variantInput = form.querySelector('[name="id"]');
            if (variantInput) {
              variantInput.value = defaultVariantId;
            }
          }

          // Get quantity from Alpine.js input
          var alpineQuantityInput = document.getElementById("Quantity-selector-variant");
          if (alpineQuantityInput) {
            var quantity = alpineQuantityInput.value;
            var formQuantityInput = form.querySelector('[name="quantity"]');
            if (formQuantityInput) {
              formQuantityInput.value = quantity;
            }
          }
        }
      });
    });
  }, [purchaseType]);

  // Use firstAvailableVariant instead of selectedVariant
  var {
    price,
    compareAtPrice,
    OriginalCompareAtPrice
  } = firstAvailableVariant;

  // Remove dollar signs and parse the values to floats
  var numPriceWithoutCurrency = Number.parseFloat(price.replace("$", "")) || 0;
  var compareAtPriceWithoutCurrency = Number.parseFloat(compareAtPrice.replace("$", "")) || 0;
  var OriginalComparePrice = Number.parseFloat(OriginalCompareAtPrice.replace("$", "")) || 0;
  var showDiscountedPrice = compareAtPriceWithoutCurrency > numPriceWithoutCurrency;
  var finalCompareAtPrice = compareAtPrice;
  if (!showDiscountedPrice) {
    finalCompareAtPrice = OriginalCompareAtPrice;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (purchaseType == "subscription") {
      var quantitySelector = document.querySelector("[data-quantity-selector-subscription]");
      if (quantitySelector) {
        quantitySelector.style.display = "none";
      }
    } else {
      var _quantitySelector = document.querySelector("[data-quantity-selector-subscription]");
      if (_quantitySelector) {
        _quantitySelector.style.display = "block";
      }
    }
  }, [purchaseType]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "onetime-container__onetime-wrapper tw-border tw-border-[#D7D7D7] tw-cursor-pointer variant-container__var-wrapper ".concat(purchaseType === "onetime" ? "active tw-border tw-border-black" : ""),
    onClick: () => {
      onUpdate("onetime");
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "onetime-container__onetime-label"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "".concat(purchaseType === "onetime" ? "active tw-border-black" : "tw-border-gray-300", " tw-border tw-p-1.5 tw-rounded-full tw-h-full tw-flex tw-items-center tw-justify-center")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-w-1 tw-h-1 ".concat(purchaseType === "onetime" ? "active tw-bg-[#2589C4] !tw-w-2 !tw-h-2 tw-rounded-full" : "")
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "One-time Purchase")), purchaseType === "onetime" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "onetime-container__oneTime-Price !tw-font-[400]"
  }, showDiscountedPrice && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "sub-compare-at-price"
  }, finalCompareAtPrice), "\xA0", price)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OnetimeOptions);

/***/ }),

/***/ "./js/components/react/subscription-options.js":
/*!*****************************************************!*\
  !*** ./js/components/react/subscription-options.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frequency_options__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./frequency-options */ "./js/components/react/frequency-options.js");
/* harmony import */ var _variant_options__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./variant-options */ "./js/components/react/variant-options.js");



var SubscriptionOptions = _ref => {
  var {
    updateSellingPlan,
    sellingplan,
    selectedVariant,
    selectedSellingPlan,
    onUpdate,
    purchaseType,
    subscription_plan,
    updateSelectedVariant,
    variants,
    options
  } = _ref;
  var {
    price,
    priceWithoutCurrency
  } = selectedVariant || {};
  var {
    value,
    value_type,
    price: afterSubscriptionPrice
  } = selectedSellingPlan || {};
  var [subscriptionBenefits, setSubscriptionBenefits] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);

  // Improved parsing to handle different number formats
  var discountNum = parseFloat(String(value).replace(/[^\d.-]/g, '')) || 0;
  var numPriceWithoutCurrency = parseFloat(String(priceWithoutCurrency || '0').replace(/[^\d.-]/g, '')) || 0;
  var numPrice = parseFloat(String(price || '0').replace(/[^\d.-]/g, '')) || 0;
  var calculateDiscountedPrice = function calculateDiscountedPrice() {
    var offerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    if (offerType === 'percentage') {
      return (numPriceWithoutCurrency * (1 - discountNum / 100)).toFixed(2);
    } else if (offerType === 'fixed_amount') {
      return (numPriceWithoutCurrency - discountNum).toFixed(2);
    } else if (offerType === 'price') {
      return discountNum.toFixed(2);
    }
    return numPriceWithoutCurrency.toFixed(2);
  };

  // More reliable comparison for showing original price
  var shouldShowOriginalPrice = () => {
    var calculatedPrice = parseFloat(calculateDiscountedPrice(value_type));
    return !isNaN(calculatedPrice) && !isNaN(numPrice) && calculatedPrice < numPrice;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (selectedSellingPlan !== null && selectedSellingPlan !== void 0 && selectedSellingPlan.frequency) {
      var plan = subscription_plan.find(plan => selectedSellingPlan.frequency === plan.frequency);
      if (plan && Array.isArray(plan.benefits)) {
        setSubscriptionBenefits(plan.benefits);
      } else {
        setSubscriptionBenefits([]);
      }
    }
  }, [selectedSellingPlan, subscription_plan]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative tw-w-full tw-cursor-pointer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative tw-w-full py-5 px-2.5 tw-border ".concat(purchaseType !== 'onetime' ? 'tw-border-black tw-bg-white' : 'tw-border-gray-200'),
    onClick: () => {
      onUpdate("subscription");
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-w-5 tw-h-5 tw-border tw-rounded-full tw-mr-3 tw-cursor-pointer ".concat(purchaseType === 'subscription' ? 'tw-border-black tw-bg-white' : 'tw-border-gray-300')
  }, purchaseType === 'subscription' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#2589C4]"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex-grow tw-flex tw-flex-wrap tw-justify-between"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-items-center tw-gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-font-semibold"
  }, "Subscribe ", discountNum > 0 && "& Save"), discountNum > 0 && value_type === 'percentage' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-bg-[#2589C4] tw-text-white tw-text-[10px] tw-px-2 tw-py-0.5 tw-rounded-[40px] tw-p-2 tw-pl-[9px] tw-pr-[9px]"
  }, "SAVE ", discountNum, "%")), purchaseType === "subscription" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-text-sm tw-mt-[2px]"
  }, shouldShowOriginalPrice() && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-line-through tw-text-gray-400 tw-mr-2"
  }, "$", numPrice.toFixed(2)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-font-[400]"
  }, afterSubscriptionPrice || "$".concat(calculateDiscountedPrice(value_type)))))), purchaseType === "subscription" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-space-y-3 tw-mt-[18px] tw-ml-[10.3%] xl:tw-ml-[5.3%]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_frequency_options__WEBPACK_IMPORTED_MODULE_1__["default"], {
    sellingplan: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.selling_plan_allocations) || [],
    selectedSellingPlan: selectedSellingPlan,
    onUpdate: updateSellingPlan,
    subscriptionPlan: subscription_plan
  }), (variants === null || variants === void 0 ? void 0 : variants.length) > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_variant_options__WEBPACK_IMPORTED_MODULE_2__["default"], {
    variants: variants,
    selectedVariant: selectedVariant,
    onUpdate: updateSelectedVariant,
    options: options,
    selectedSellingPlan: selectedSellingPlan,
    purchaseType: purchaseType
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SubscriptionOptions);

/***/ }),

/***/ "./js/components/react/variant-options.js":
/*!************************************************!*\
  !*** ./js/components/react/variant-options.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    variants,
    selectedVariant,
    onUpdate,
    options,
    selectedSellingPlan,
    purchaseType
  } = _ref;
  var [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var [optionName] = Object.keys(options);
  var {
    discount
  } = selectedSellingPlan || {};
  var handleSelectChange = ev => {
    var variantId = ev.target.value;
    var variant = variants.find(v => v.id === variantId);
    if (variant) {
      onUpdate(variant);
    }
  };
  var handleOptionClick = variant => {
    handleSelectChange({
      target: {
        value: variant.id
      }
    });
    setIsOpen(false);
  };
  var handleClickOutside = e => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-gap-3 tw-flex-wrap tw-items-center variant-container__var-options"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "variant-container__opt-label !tw-m-0 tw-max-w-fit tw-min-w-[75px] md:tw-min-w-[89px]"
  }, optionName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "variant-container__var-options tw-relative tw-w-[160px]",
    ref: dropdownRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "dropdown_content !tw-font-normal tw-border tw-p-2.5",
    onClick: () => setIsOpen(!isOpen)
  }, (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.name) || 'Select', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: isOpen ? 'dropdownOpen' : 'dropdownClose'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "7",
    viewBox: "0 0 10 7",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "0.707107",
    y1: "1.29289",
    x2: "5.70711",
    y2: "6.29289",
    stroke: "#000000",
    strokeWidth: "2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.29289",
    y1: "6.29289",
    x2: "9.29289",
    y2: "1.29289",
    stroke: "#000000",
    strokeWidth: "2"
  }))), isOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency_options tw-bg-[#4c4c4c] tw-rounded-lg"
  }, variants.map(variant => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    key: variant.id,
    className: "frequency-container__freq-name variant-container__var-name tw-text-white tw-whitespace-nowrap tw-cursor-pointer ",
    onClick: () => handleOptionClick(variant)
  }, variant.name)))))));
});

/***/ }),

/***/ "./js/components/react/variant-selector.js":
/*!*************************************************!*\
  !*** ./js/components/react/variant-selector.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _onetime_options__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./onetime-options */ "./js/components/react/onetime-options.js");
/* harmony import */ var _subscription_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./subscription-options */ "./js/components/react/subscription-options.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var _shopifyData$data, _selectedSubscription, _selectedSubscription2;
  var {
    shopifyData
  } = _ref;
  var [purchaseType, setPurchaseType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("onetime");
  var [dataLoaded, setDataLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1); // Add quantity state

  // Add defensive checks for data structure
  var data = (shopifyData === null || shopifyData === void 0 || (_shopifyData$data = shopifyData.data) === null || _shopifyData$data === void 0 ? void 0 : _shopifyData$data.data) || {};
  var {
    variants = [],
    selected = "",
    subscription_plan = [],
    options = {}
  } = data;

  // Find variants with subscription options
  var subscriptionVariants = variants.filter(v => v.selling_plan_allocations && v.selling_plan_allocations.length > 0);

  // Separate one-time variants (first variant) from subscription variants
  var firstAvailableVariant = variants.find(v => v.available) || variants[0] || {};

  // Initialize selected variants with proper fallbacks
  var [selectedVariant, setSelectedVariant] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(variants.find(variant => variant.id === selected) || firstAvailableVariant);
  var [selectedSubscriptionVariant, setSelectedSubscriptionVariant] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(subscriptionVariants[0] || null);

  // Get selling plans from the selected variant's allocations with proper fallbacks
  var [selectedSellingPlan, setSelectedSellingPlan] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((selectedSubscriptionVariant === null || selectedSubscriptionVariant === void 0 || (_selectedSubscription = selectedSubscriptionVariant.selling_plan_allocations) === null || _selectedSubscription === void 0 ? void 0 : _selectedSubscription[0]) || {});

  // Set data loaded flag when component mounts
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setDataLoaded(true);
    console.log("Subscription data loaded:", {
      variants,
      subscriptionVariants,
      selectedSubscriptionVariant,
      selectedSellingPlan
    });

    // Add event listener for quantity changes
    var setupQuantityListeners = () => {
      var quantityInputs = document.querySelectorAll("[data-quantity-input]");
      quantityInputs.forEach(input => {
        input.addEventListener("change", e => {
          setQuantity(Number.parseInt(e.target.value, 10) || 1);
        });
      });
    };

    // Initial setup
    setupQuantityListeners();

    // Setup again after a short delay to catch dynamically added elements
    setTimeout(setupQuantityListeners, 500);
    return () => {
      // Clean up event listeners
      var quantityInputs = document.querySelectorAll("[data-quantity-input]");
      quantityInputs.forEach(input => {
        input.removeEventListener("change", e => {
          setQuantity(Number.parseInt(e.target.value, 10) || 1);
        });
      });
    };
  }, []);
  var updateSelectedVariant = variantObj => {
    if (variantObj.id) {
      var variant = variants.find(v => v.id === variantObj.id);
      if (variant) {
        setSelectedVariant(variant);
      }
    } else if (variantObj) {
      setSelectedVariant(variantObj);
    }
  };
  var updateSelectedSubscriptionVariant = variantObj => {
    if (variantObj.id) {
      var variant = variants.find(v => v.id === variantObj.id);
      if (variant) {
        var _variant$selling_plan;
        setSelectedSubscriptionVariant(variant);
        // Reset selling plan when variant changes
        setSelectedSellingPlan(((_variant$selling_plan = variant.selling_plan_allocations) === null || _variant$selling_plan === void 0 ? void 0 : _variant$selling_plan[0]) || {});
      }
    } else if (variantObj) {
      var _variantObj$selling_p;
      setSelectedSubscriptionVariant(variantObj);
      setSelectedSellingPlan(((_variantObj$selling_p = variantObj.selling_plan_allocations) === null || _variantObj$selling_p === void 0 ? void 0 : _variantObj$selling_p[0]) || {});
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (purchaseType == "onetime") {
      var firstAvailable = variants.find(variant => variant.available) || variants[0];
      setSelectedVariant(firstAvailable || {});
      var oneTimePrice = document.querySelector('[data-product-price]');
      oneTimePrice.style.display = "block";
    } else {
      // Make sure we have a valid subscription variant selected
      if (!selectedSubscriptionVariant && subscriptionVariants.length > 0) {
        var firstEnabled = subscriptionVariants.find(v => v.available) || subscriptionVariants[0];
        if (firstEnabled) {
          var _firstEnabled$selling;
          setSelectedSubscriptionVariant(firstEnabled);
          setSelectedSellingPlan(((_firstEnabled$selling = firstEnabled.selling_plan_allocations) === null || _firstEnabled$selling === void 0 ? void 0 : _firstEnabled$selling[0]) || {});
        }
      }
    }
  }, [purchaseType, variants, dataLoaded]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var {
      priceWithoutCurrency
    } = selectedVariant || {};
    var price = (priceWithoutCurrency === null || priceWithoutCurrency === void 0 ? void 0 : priceWithoutCurrency.trim()) || "0";
    if (purchaseType !== "onetime" && selectedSellingPlan) {
      var {
        value,
        value_type
      } = selectedSellingPlan || {};
      var discountNum = Number.parseFloat(value) || 0;
      var numPriceWithoutCurrency = Number.parseFloat(priceWithoutCurrency) || 0;
      var calculateDiscountedPrice = function calculateDiscountedPrice() {
        var offerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        if (offerType == "percentage") {
          return (numPriceWithoutCurrency * (1 - discountNum / 100)).toFixed(2);
        } else if (offerType == "fixed_amount") {
          return (numPriceWithoutCurrency - discountNum).toFixed(2);
        } else if (offerType == "price") {
          return discountNum.toFixed(2);
        }
        return numPriceWithoutCurrency.toFixed(2);
      };
      price = calculateDiscountedPrice(value_type);
    }
    document.querySelectorAll("[data-segmented-price]").forEach(priceInput => priceInput.value = price);
  }, [selectedVariant, purchaseType, selectedSellingPlan]);
  var handleSwitch = purchaseType => {
    setPurchaseType(purchaseType);
  };
  var updateSellingPlan = sellingPlanObj => {
    setSelectedSellingPlan(_objectSpread({}, sellingPlanObj));
  };
  var updateInputValues = (inputs, value) => {
    inputs.forEach(input => {
      if (input.closest("[data-product-form]")) {
        input.value = value;
      }
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var variantInputs = document.querySelectorAll("[data-variant-selector]");
    var sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
    var sellingFrequencyInput = document.querySelectorAll("[data-selling-frequency]");
    var quantityInputs = document.querySelectorAll('input[name="quantity"]');
    if (purchaseType == "subscription") {
      var oneTimePrice = document.querySelector('[data-product-price]');
      oneTimePrice.style.display = "none";
      if (selectedSubscriptionVariant !== null && selectedSubscriptionVariant !== void 0 && selectedSubscriptionVariant.id) {
        updateInputValues(variantInputs, selectedSubscriptionVariant.id);
      }
      if (selectedSellingPlan !== null && selectedSellingPlan !== void 0 && selectedSellingPlan.selling_plan_id) {
        updateInputValues(sellingPlanInputs, selectedSellingPlan.selling_plan_id);
      }
      if (selectedSellingPlan !== null && selectedSellingPlan !== void 0 && selectedSellingPlan.frequency) {
        updateInputValues(sellingFrequencyInput, selectedSellingPlan.frequency);
      }
    } else {
      if (selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.id) {
        updateInputValues(variantInputs, selectedVariant.id);
      }
      updateInputValues(sellingPlanInputs, "");
      updateInputValues(sellingFrequencyInput, "");

      // For one-time purchase, get quantity from Alpine.js input
      var alpineQuantityInput = document.querySelector("[data-quantity-selector-onetime]");
      if (alpineQuantityInput) {
        var _quantity = alpineQuantityInput.value;
        var _quantityInputs = document.querySelectorAll('input[name="quantity"]');
        updateInputValues(_quantityInputs, _quantity);
      }
    }

    // Update quantity inputs with current quantity
    // updateInputValues(quantityInputs, quantity.toString())

    var priceContainer = document.querySelector(".product-price__current-price");
    if (priceContainer && selectedVariant !== null && selectedVariant !== void 0 && selectedVariant.price) {
      priceContainer.innerHTML = selectedVariant.price;
    }
  }, [selectedVariant, purchaseType, selectedSellingPlan, selectedSubscriptionVariant, quantity]);

  // Check if we have subscription variants available
  var hasSubscriptionOptions = subscriptionVariants.length > 0 && (selectedSubscriptionVariant === null || selectedSubscriptionVariant === void 0 || (_selectedSubscription2 = selectedSubscriptionVariant.selling_plan_allocations) === null || _selectedSubscription2 === void 0 ? void 0 : _selectedSubscription2.length) > 0;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "variant-container__purchaseType-wrapper tw-gap-[14px] sm:tw-gap-[28px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_onetime_options__WEBPACK_IMPORTED_MODULE_2__["default"], {
    firstAvailableVariant: firstAvailableVariant,
    purchaseType: purchaseType,
    onUpdate: handleSwitch
  }), hasSubscriptionOptions && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_subscription_options__WEBPACK_IMPORTED_MODULE_3__["default"], {
    updateSellingPlan: updateSellingPlan,
    sellingplan: selectedSubscriptionVariant.selling_plan_allocations,
    selectedVariant: selectedSubscriptionVariant,
    purchaseType: purchaseType,
    selectedSellingPlan: selectedSellingPlan,
    onUpdate: handleSwitch,
    subscription_plan: subscription_plan,
    updateSelectedVariant: updateSelectedSubscriptionVariant,
    variants: subscriptionVariants,
    options: options,
    quantity: quantity,
    setQuantity: setQuantity
  }));
});

/***/ })

}]);